import { useState } from 'react';
import { ImportTable, ImportResult } from '../utils/importUtils';

interface UseImportOptions {
  table: ImportTable;
  onImport: (data: any[]) => Promise<ImportResult>;
}

export const useImport = ({ table, onImport }: UseImportOptions) => {
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);

  const openImportModal = () => {
    setIsImportModalOpen(true);
  };

  const closeImportModal = () => {
    setIsImportModalOpen(false);
  };

  const handleImport = async (data: any[]): Promise<ImportResult> => {
    try {
      const result = await onImport(data);
      return result;
    } catch (error) {
      console.error('Import error:', error);
      return {
        success: 0,
        errors: ['Error importing data'], // This will be translated in the component
        warnings: []
      };
    }
  };

  return {
    isImportModalOpen,
    openImportModal,
    closeImportModal,
    handleImport,
    table
  };
};
